import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import ReactTable from 'react-table';
import classNames from 'classnames';
import Link from 'react-router/lib/Link';

import Title from '../../../Title';
import Valuation from './Valuation';
import * as shapes from '../../../shapes';
import { NewInventory, StockTaking } from '../../BulkInventoryUpdate';
import { RoleAllowShop } from '../../../../auth/roleAware';

const SharedProductList = props => (
  <div className="c-wrapper c-wrapper-allow-header">
    <Title>Products</Title>
    <div className="u-margin-auto u-mv-">
      <div className="o-flexbox o-flexbox--content-align-center">
        <div className="o-flexbox">
          <div display-if={props.canSeeStockTaking} className="u-mr-">
            <StockTaking products={props.products} />
          </div>
          <div className="u-mr-">
            <NewInventory display-if={props.canSeeNewInventory} products={props.products} />
          </div>
          <button
            display-if={props.canSeeLowInventory}
            onClick={props.exportLowInventoryToCsv}
            disabled={props.lowInventoryProductsCount === 0}
            className="c-btn c-btn--medium"
          >
            Low Inventory Report ({props.lowInventoryProductsCount})
          </button>
        </div>
        <Valuation display-if={!!props.products.length} items={props.products} />
        <div className="o-flexbox">
          <button
            display-if={props.canExportToCsv}
            className="c-btn c-btn--medium u-width-130 u-mr-"
            onClick={props.exportProductsToCsv}
          >
            Export to csv
          </button>
          <RoleAllowShop>
            <Link
              display-if={props.canCreatePurchaseOrder}
              className="c-btn c-btn--medium u-width-130 u-mr-"
              to={`${props.baseUrl}/purchase-orders/create`}
            >
              Create PO
            </Link>
          </RoleAllowShop>
          <Link
            className="c-btn c-btn--medium u-width-130"
            display-if={props.canModifyProducts && !props.isCommissionBarber}
            to={`${props.baseUrl}/add`}
          >
            Add product
          </Link>
        </div>
      </div>
      <ReactTable
        className={
          classNames('c-table-card c-table-new u-table-layout-fixed u-mt c-table-with-sticky-header',
            { 'c-no-hover': !props.canModifyProducts }
          )
        }
        minRows={0}
        showPagination
        data={props.products}
        columns={props.columns}
        defaultPageSize={50}
        getTrProps={(_, row) => ({
          onClick: () => props.canModifyProducts && props.openProduct(row.original),
        })}
        PaginationComponent={paginationProps => (
          <div className="u-mt" display-if={paginationProps.pages > 0}>
            <ReactPaginate
              containerClassName="react-paginate"
              pageLinkClassName="react-paginate-item"
              previousLinkClassName="react-paginate-item"
              nextLinkClassName="react-paginate-item"
              breakLinkClassName="react-paginate-item"
              activeLinkClassName="react-paginate-item is-active"
              disabledClassName="react-paginate-disabled"
              pageCount={paginationProps.pages}
              forcePage={paginationProps.page}
              onPageChange={data => paginationProps.onPageChange(data.selected)}
              marginPagesDisplayed={8}
              pageRangeDisplayed={4}
            />
          </div>
        )}
        defaultSorted={[{ id: 'name', asc: true }]}
      />
    </div>
  </div>
);

SharedProductList.propTypes = {
  products: shapes.products,
  baseUrl: shapes.url,
  exportProductsToCsv: shapes.handler.isRequired,
  exportLowInventoryToCsv: shapes.handler.isRequired,
  isCommissionBarber: PropTypes.bool.isRequired,
  lowInventoryProductsCount: shapes.count.isRequired,
  canModifyProducts: PropTypes.bool.isRequired,
  canCreatePurchaseOrder: PropTypes.bool.isRequired,
  canSeeStockTaking: PropTypes.bool.isRequired,
  canSeeNewInventory: PropTypes.bool.isRequired,
  canSeeLowInventory: PropTypes.bool.isRequired,
  canExportToCsv: PropTypes.bool.isRequired,
  columns: PropTypes.array.isRequired,
  openProduct: shapes.handler.isRequired,
};

SharedProductList.defaultProps = {
  products: [],
  baseUrl: '/products',
};

export default SharedProductList;

